import type { MetaFunction } from "react-router";
import TermsOfService from "@/pages/terms-of-service";

export const meta: MetaFunction = () => {
  return [
    { title: "Terms of Service | Arcitext" },
    {
      name: "description",
      content: "Read the Arcitext terms of service and usage guidelines.",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/terms-of-service",
    },
  ];
};

// This route uses static pre-rendering
export default function TermsRoute() {
  return <TermsOfService />;
}
